import(/* webpackMode: "eager" */ "/app/src/app/[locale]/product/page.tsx");
